// Consultation pages are reachable through two URL shapes while the deprecated routes are kept alive:
//   - canonical: /consultations/{parsys_id}/           (parsys_id is a UUID, see models/consultations.py)
//   - deprecated: /patients/{patient_id}/consultations/{consultation_id}/
// The returned object is meant to be passed as-is to the getConsultation*Path helpers in FRONTEND/utils/routes,
// which know how to rebuild either shape. Callers should not read patientId/consultationId directly:
// they are absent on canonical URLs.
const PARSYS_ID_REGEX = /consultations\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/;
const DEPRECATED_REGEX = /patients\/(\d+)\/consultations\/(\d+)/;

export const extractConsultationParamsFromUrl = (url) => {
  // The UUID pattern cannot match a numeric consultation id, so the two regexes never compete.
  const parsysIdMatch = url.match(PARSYS_ID_REGEX);
  if (parsysIdMatch) {
    return { parsysId: parsysIdMatch[1] };
  }

  const deprecatedMatch = url.match(DEPRECATED_REGEX);
  if (deprecatedMatch) {
    return {
      patientId: deprecatedMatch[1],
      consultationId: deprecatedMatch[2],
    };
  }
  return {};
};
